"use strict";
var PaginatorController = (function () {
    function PaginatorController() {
        var _this = this;
        this.filterPageNumbers = function (actual) {
            return actual >= _this.minPageNumber() && actual <= _this.maxPageNumber();
        };
    }
    PaginatorController.prototype.getPageNumbers = function () {
        return this.pages.slice(1, this.pages.length - 1).map(function (page, index) { return index + 2; });
    };
    PaginatorController.prototype.currentIsFirst = function () { return this.currentPage === 1; };
    PaginatorController.prototype.currentIsLast = function () { return this.currentPage === this.pages.length; };
    PaginatorController.prototype.isCurrent = function (page) { return this.currentPage === page; };
    PaginatorController.prototype.moreLeft = function () { return this.minPageNumber() > 2; };
    PaginatorController.prototype.moreRight = function () { return this.maxPageNumber() < this.pages.length - 1; };
    PaginatorController.prototype.setPage = function (page) {
        this.currentPage = page;
        this.onSetPage({ page: page });
    };
    PaginatorController.prototype.maxPageNumber = function () {
        return Math.max(this.oddNumberOfPagesToShow, Math.min(this.pages.length, this.currentPage + Math.floor(this.oddNumberOfPagesToShow / 2)));
    };
    PaginatorController.prototype.minPageNumber = function () {
        return Math.min(this.pages.length - this.oddNumberOfPagesToShow + 1, Math.max(1, this.currentPage - Math.floor(this.oddNumberOfPagesToShow / 2)));
    };
    return PaginatorController;
}());
exports.PaginatorController = PaginatorController;



/** WEBPACK FOOTER **
 ** ./app/common/paginator/paginator.controller.ts
 **/